import { useState } from 'react'
import { Link } from 'react-router-dom'
import { applyActionCode, confirmPasswordReset, verifyPasswordResetCode } from 'firebase/auth'
import { getFirebaseAuth } from '../../lib/firebase'
import AuthLayout, { PasswordField } from './AuthLayout'

export default function AuthActionPage() {
  const [params] = useState(() => new URLSearchParams(window.location.search))
  const mode = params.get('mode')
  const code = params.get('oobCode')
  const valid = !!code && (mode === 'resetPassword' || mode === 'verifyEmail' || mode === 'verifyAndChangeEmail')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState(false)
  const [error, setError] = useState('')
  async function submit(e: React.FormEvent) {
    e.preventDefault()
    if (busy || !valid) return
    if (mode === 'resetPassword' && password.length < 12) { setError('Use at least 12 characters.'); return }
    setBusy(true); setError('')
    try {
      const auth = getFirebaseAuth()
      if (!auth || (params.get('apiKey') && params.get('apiKey') !== auth.app.options.apiKey)) throw new Error('Invalid environment')
      if (mode === 'verifyEmail' || mode === 'verifyAndChangeEmail') await applyActionCode(auth, code!)
      else { await verifyPasswordResetCode(auth, code!); await confirmPasswordReset(auth, code!, password) }
      window.history.replaceState(null, '', '/auth/action')
      setPassword(''); setDone(true)
    } catch { setError('This link could not be completed. It may be expired, already used, or for another environment. Request a new link or try again.') }
    finally { setBusy(false) }
  }
  return <AuthLayout>
    <h1 className="auth-title">{done ? 'You’re all set.' : mode === 'resetPassword' ? 'Reset your password.' : 'Verify your email.'}</h1>
    {!valid && <p className="auth-error" role="alert">This email link is incomplete or unsupported.</p>}
    {error && <p className="auth-error" role="alert">{error}</p>}
    {valid && !done && <form className="auth-form" onSubmit={submit}>
      {mode === 'resetPassword' && <><PasswordField value={password} onChange={setPassword} autoComplete="new-password" /><p>Use at least 12 characters.</p></>}
      <button className="auth-btn auth-btn--primary" disabled={busy}>{busy ? 'Working…' : mode === 'resetPassword' ? 'Save password' : 'Verify email'}</button>
    </form>}
    {done && <p role="status">{mode === 'verifyEmail' ? 'Return to your onboarding page and select “I’ve verified my email”.' : mode === 'verifyAndChangeEmail' ? 'Your email has been updated. Sign in with your new address.' : 'Your password has been updated. You can now sign in.'}</p>}
    <p className="auth-footer"><Link to="/login">Return to sign in</Link> · <Link to="/forgot-password">Get a reset link</Link></p>
  </AuthLayout>
}
